import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import {
    Box,
    Divider,
    Typography,
    Stack,
    MenuItem,
    Avatar,
    IconButton,
    Popover
} from '@mui/material';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import i18n from '../../../i18n';
//
import AccountEmailRow from './AccountEmailRow';
import {
    accountAvatarSx,
    accountIdentitySx,
    accountNameSx,
    accountTriggerSx,
    menuDividerSx,
    menuPaperSx
} from './headerTriggers.styles';
import ProfileDialog from '../../../pages/dialogs/ProfileDialog';
import ChangePasswordDialog from '../../../pages/dialogs/ChangePasswordDialog';
import { useStateSelector } from '../../../context/StateSelectors';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
    {
        id: 'home',
        label: 'profile.home',
        icon: 'eva:home-fill',
        url: '/app/dashboard'
    },
    {
        id: 'profile',
        label: 'profile.profile',
        icon: 'eva:person-fill'
    },
    {
        id: 'changePassword',
        label: 'text.changePassword',
        icon: 'eva:credit-card-outline'
    }
];

// Also the profile form of the phone's page menu (MobilePageMenu).
export const UsersHead = [
    { id: 'firstName', label: 'firstName', alignRight: false, cell: 'Text' },
    { id: 'lastName', label: 'lastName', alignRight: false, cell: 'Text' },
    { id: 'gender', label: 'gender', alignRight: false, cell: 'Items', items: ['male', 'female', 'other'], enumGroup: 'gender' },
    { id: 'birthDate', label: 'birthDate', alignRight: false, cell: 'Date', openTo: 'year', disableFuture: true },
    { id: 'twoFactorEnabled', label: 'twoFactorEnabled', alignRight: false, cell: 'Dialog2FA' },
];

//-----------------------------------------------------------------------------
export default function AccountPopover() {
    const server = useStateSelector((state) => state.server);
    const userInfo = useStateSelector((state) => state.userInfo);

    const navigate = useNavigate();

    const [open, setOpen] = useState(null);
    const [profileDialogOpen, setProfileDialogOpen] = useState(false);

    const [passDialogOpen, setPassDialogOpen] = useState(false);

    const openChangePassDialog = (event) => setPassDialogOpen(event);
    const closeChangePassDialog = () => setPassDialogOpen(false);

    const handleOpen = (event) => setOpen(event.currentTarget);
    const handleClose = () => setOpen(null);

    const handleLogout = () => {
        server.auth.logoutUser();
        navigate('/login', { replace: true });
    };

    const handleRedirect = (option) => {
        if (option.url) {
            handleClose();
            navigate(option.url, { replace: true });
        }
        if (option.id === 'profile') {
            handleClose();
            setProfileDialogOpen(true);
        } else if (option.id === 'changePassword') {
            handleClose();
            openChangePassDialog(true);
        }
    };


    // Missing parts are left out, rather than shown as "undefined".
    const fullName = [userInfo?.firstName, userInfo?.lastName]
        .filter(Boolean)
        .join(' ');

    const currentUserData = userInfo ? userInfo : {};
    // leave only field that are in UsersHead
    const filteredUserData = Object.keys(currentUserData)
        .filter((key) => UsersHead.some((head) => head.id === key))
        .reduce((obj, key) => {
            obj[key] = currentUserData[key];
            return obj;
        }, {});

    return (
        <>
            <IconButton
                onClick={handleOpen}
                aria-label={i18n.t('profile.profile')}
                aria-haspopup="true"
                aria-expanded={Boolean(open)}
                sx={accountTriggerSx(Boolean(open))}
            >
                <Avatar sx={accountAvatarSx}>
                    <PersonOutlineRoundedIcon />
                </Avatar>
            </IconButton>

            <Popover
                open={Boolean(open)}
                anchorEl={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                slotProps={{ paper: { sx: menuPaperSx(264) } }}
            >
                <Box sx={accountIdentitySx}>
                    <Typography sx={accountNameSx} noWrap title={fullName}>
                        {fullName}
                    </Typography>
                    <AccountEmailRow email={userInfo?.email} />
                </Box>

                <Divider sx={menuDividerSx} />

                <Stack spacing={0.25}>
                    {MENU_OPTIONS.map((option) => (
                        <MenuItem
                            key={option.label}
                            onClick={() => handleRedirect(option)}
                        >
                            {i18n.t(option.label)}
                        </MenuItem>
                    ))}
                </Stack>

                <Divider sx={menuDividerSx} />

                <MenuItem onClick={handleLogout}>
                    {i18n.t('profile.logout')}
                </MenuItem>
            </Popover>

            <ProfileDialog
                dialogOpen={profileDialogOpen}
                dialogData={filteredUserData}
                Head={UsersHead}
                onSave={(data) => {
                    setProfileDialogOpen(false);
                }}
                onClose={() => setProfileDialogOpen(false)}
            />
            <ChangePasswordDialog
                open={passDialogOpen}
                onClose={closeChangePassDialog}
                userId={userInfo?.id}
                askCurrent
            />
        </>
    );
}
